import { render } from "./ClientSettings.vue?vue&type=template&id=6db39cbd"
import script from "./ClientSettings.vue?vue&type=script&lang=js"
export * from "./ClientSettings.vue?vue&type=script&lang=js"

import "./ClientSettings.vue?vue&type=style&index=0&id=6db39cbd&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/DACY_Demo_Server/kbdemo_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__